import { ColourTheme } from '@/app-modules/store/modules/user-preferences';

interface IColourThemeSelection {
  colourTheme: ColourTheme;
  friendlyName: string;
}

const DefaultColourThemeSelections: IColourThemeSelection[] = [
  { colourTheme: ColourTheme.Light, friendlyName: 'Light Theme' },
  { colourTheme: ColourTheme.Dark, friendlyName: 'Dark Theme' }
];

export { IColourThemeSelection, DefaultColourThemeSelections };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/user-settings/_components/colour-theme/_domain/models/index.ts